import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightning = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M3.18344 10.4815L6.03857 2.03704C6.24025 1.44444 6.86483 1 7.47066 1L13.8319 1C14.3998 1 14.7897 1.48148 14.6717 2.03704C14.648 2.14815 14.5866 2.25926 14.5251 2.37037L11.815 6.92592L17.0782 6.92592C17.8354 6.92592 18.3453 7.55555 18.1879 8.29629C18.1249 8.59258 17.9562 8.85184 17.7575 9.07406L8.27536 19.4815C7.98519 19.7778 7.55931 20 7.18067 20H7.06707C6.46124 20 6.10921 19.5185 6.23517 18.9259C6.25092 18.8518 6.27453 18.7407 6.32814 18.6666L9.59566 11.6667L4.14319 11.6667C3.46163 11.6667 3.04174 11.1481 3.18344 10.4815Z"
	})
});
const ForwardRef = forwardRef(SvgLightning);
export default ForwardRef;
